


















































import { Component, Vue, Prop } from "vue-property-decorator"
import { showVaildMsg, validateCompare, validateOldPwd, validatePwd } from '@/configs/validate'
import { checkPwd, updatePwd, UserPwdData } from '@/api/systemManage/user'
import FormDialog from '@/components/dialog/formDialog.vue'
import Element from 'element-ui'
import sysLocalStorage, { enStorageName } from "@/store/localStorage"

const getFormRules = (id: number, form: { [key: string]: string }) => {
  return {
    OldPassword: [
      { required: true, message: '请输入原密码' },
      { validator: oldPwdValidator(id), trigger: 'blur' }
    ],
    NewPassword: [
      { required: true, validator: validatePwd, trigger: 'blur' },
      { validator: validateOldPwd('OldPassword', '新密码和原密码一样，请重新输入一个新密码', form), trigger: 'blur' }
    ],
    ConfirmPassword: [
      { required: true, min: 8, message: '请输入确认密码' },
      { validator: validateCompare('NewPassword', '两次输入的密码不一致', form), trigger: 'blur' }
    ]
  }
}
const oldPwdValidator = (id: number) => {
  return (rule: any, value: any, callback: (error?: Error) => void) => {
    checkPwd(id, value).then((response: { data: any }) => {
      const data = response.data
      if (data) {
        callback()
      } else {
        callback(new Error('原密码不正确，请重新输入'))
      }
    })
  }
}
@Component({
  components: {
    FormDialog
  }
})
export default class UserModifyPwd extends Vue {
  /************************* 以下为控件自定义代码 *************************/
  public collapseNames = ['info']

  public emptyForm: UserPwdData = {
    UserId: 0,
    OldPassword: '',
    NewPassword: '',
    ConfirmPassword: ''
  }
  public form = Object.assign({}, this.emptyForm)
  public rules = getFormRules(this.form.UserId, this.form)
  public $refs!: {
    formData: Element.Form
  }
  /*************************vue 组件互相通信 以下代码可共用*************************/
  public name: string = "UserModifyPwd"
  // 关闭窗口，在 dialog 的 :before-close属性中触发，然后调用父级中的方法
  @Prop({ default: null })
  public closeDialog!: () => void
  // 打开事件
  public openEvent: string = this.name + '_Open'
  // 提交事件
  public submitEvent: string = this.name + '_Submit'
  public showDialog: boolean = false
  public loading: boolean = false

  // public $refs!: {
  //   formData: Element.Form
  // }
  public created() { }
  //是否是系统通知修改的
  public sysNotice: boolean = false
  public mounted() {
    //接收数据，父页面使用 window.eventBus.$emit() 发送数据
    window.eventBus.$on(this.openEvent,
      (info: { userId: number, isNotice?: boolean }) => {
        //isNotice 是否是系统通知修改的(密码太简单)
        this.sysNotice = false
        if (info.isNotice) {
          this.sysNotice = true
        }
        this.open()
        this.fetchSource()
        this.fetchData(info)
      }
    )
  }
  public beforeDestroy() {
    //销毁事件，避免重复注册
    window.eventBus.$off(this.openEvent)
  }
  public open() {
    this.showDialog = true
  }
  public close() {
    this.showDialog = false
    if (this.sysNotice) {
      sysLocalStorage.removeItem(enStorageName[enStorageName.ChangePwdTips])
    }
    // this.$refs.formData.resetFields()
    if (this.closeDialog) {
      this.closeDialog()
    }
  }
  public callBack() {
    window.eventBus.$emit(this.submitEvent)
  }
  public fetchSource() {
  }
  public fetchData(info: { userId: number }) {
    this.form = Object.assign({}, this.emptyForm)
    this.form.UserId = info.userId
    this.rules = getFormRules(this.form.UserId, this.form)
  }
  public onSubmit() {
    this.$refs.formData.validate((valid: boolean, obj: any) => {
      if (valid) {
        const f = Object.assign({}, this.form)
        updatePwd(f.UserId, f.NewPassword).then((response: { data: any }) => {
          const data = response.data
          if (data && !data.IsError) {
            this.$message({
              message: '密码修改成功',
              type: 'success'
            })
            this.close()
            this.callBack()
          } else {
            this.$message({
              dangerouslyUseHTMLString: true, message: `${data.Message}`, type: 'warning'
            })
          }
        }, (data: any) => {
          console.log(data)
        })
      }
      else {
        showVaildMsg(this.$message, obj)
      }
    })
  }
  /*************************vue 组件互相通信 以上代码可共用*************************/
}
